/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.0.0
 */

/**
 * @description Interface for subscriberMobile labels
 * @interface ISubscriberLabel
 */
export interface ISubscriberLabel {
    id: number;
    name: string;
    color: string;
}

/**
 * @description Interface for subscriberMobile table data
 * @interface ISubscriber
 */
export interface ISubscriberMobile {
    accessName: string;
    account: {
        id: number;
        number: string;
    };
    accountName: string;
    assistantCampaignsCount: number;
    balance: {
        value: number;
        date: number;
    };
    checked: boolean;
    cityNumber?: string;
    contract: string;
    contractNumber: string;
    coordinatorCampaignsCount: number;
    dcRules: string;
    icc: string;
    id: string;
    inn?: string;
    kpp?: string;
    labels: ISubscriberLabel[];
    loyaltyStatus: string;
    msisdn: string;
    name?: string;
    number: string;
    numberType: string;
    persDataHintCode?: string;
    persDataLockDate?: number;
    persDataStatusId: number;
    persDataStatusName: string;
    position: string;
    ratePlan: string;
    status: string;
    subdivisionKpp?: string;
    subdivisionName?: string;
    zone: string;
    zoneId: number;
}

/**
 * @description Subscriber table columns
 */
export enum SubscriberMobileField {
    accessName = 'accessName',
    account = 'account',
    accountName = 'accountName',
    assistantCampaignsCount = 'assistantCampaignsCount',
    balance = 'balance',
    cityNumber = 'cityNumber',
    contractNumber = 'contractNumber',
    coordinatorCampaignsCount = 'coordinatorCampaignsCount',
    dcRules = 'dcRules',
    icc = 'icc',
    inn = 'inn',
    kpp = 'kpp',
    labels = 'labels',
    loyaltyStatus = 'loyaltyStatus',
    msisdn = 'msisdn',
    name = 'name',
    numberType = 'numberType',
    persDataLockDate = 'persDataLockDate',
    persDataStatusName = 'persDataStatusName',
    position = 'position',
    ratePlan = 'ratePlan',
    status = 'status',
    subdivisionKpp = 'subdivisionKpp',
    subdivisionName = 'subdivisionName',
    zone = 'zone',
}

export const SubscriberColumnNames: SubscriberMobileField[] = [
    SubscriberMobileField.msisdn,
    SubscriberMobileField.accessName,
    SubscriberMobileField.account,
    SubscriberMobileField.accountName,
    SubscriberMobileField.assistantCampaignsCount,
    SubscriberMobileField.balance,
    SubscriberMobileField.cityNumber,
    SubscriberMobileField.contractNumber,
    SubscriberMobileField.coordinatorCampaignsCount,
    SubscriberMobileField.dcRules,
    SubscriberMobileField.icc,
    SubscriberMobileField.labels,
    SubscriberMobileField.loyaltyStatus,
    SubscriberMobileField.name,
    SubscriberMobileField.numberType,
    SubscriberMobileField.persDataLockDate,
    SubscriberMobileField.persDataStatusName,
    SubscriberMobileField.position,
    SubscriberMobileField.ratePlan,
    SubscriberMobileField.status,
    SubscriberMobileField.subdivisionKpp,
    SubscriberMobileField.subdivisionName,
    SubscriberMobileField.zone,
];
